import React, { useEffect } from 'react';

const Logo = () => {
  return (
      <a href="/" className="navbar-brand">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 360">
              <defs>
                  <style>
                      {
                          ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#CC432F;}"
                      }
                  </style>
                  <clipPath id="clip-path">
                      <polyline
                          className="cls-1"
                          points="5 448.49 5 0 1147.39 0 1147.39 448.49"
                      />
                  </clipPath>
              </defs>
              <rect width="100%" height="100%" fill="#163B59"/>
              <g className="cls-2">
                  <path
                      className="cls-3"
                      d="M179.41,180.29a50.75,50.75,0,0,1,87.91-50.75l87.92-50.76A152.28,152.28,0,0,0,91.49,231.05l87.92-50.76Z"
                  />
                  <path
                      className="cls-3"
                      d="M91.73,230.93a50.75,50.75,0,1,0,87.91-50.75l87.91-50.76A152.27,152.27,0,0,1,3.81,281.69l87.92-50.76Z"
                  />
              </g>
          </svg>
      </a>
  );
};

export default Logo;
